import $ from 'jquery';
import Cookies from 'js-cookie';

export function initTicketInformationBannerBlock() {
	const $ticketInformationBanner = $('.ticketInformationBanner');

	if (!$ticketInformationBanner.length) {
		return;
	}

	const cookieName                      = 'visitedTicketInformationBanners',
	      itemId                          = $ticketInformationBanner.data('itemId'),
	      visitedTicketInformationBanners = JSON.parse(Cookies.get(cookieName) || '[]');

	if (!visitedTicketInformationBanners.includes(itemId)) {
		$ticketInformationBanner.show();
	}

	$ticketInformationBanner
		.on('click', '.close', (event) => {
			const $banner = $(event.target).closest('.ticketInformationBanner');

			if (itemId !== undefined) {
				visitedTicketInformationBanners.push(itemId);
			}

			$banner.hide();
			$banner.siblings('.ticketInformationBannerOpenedBackground').hide();
			$('body').removeClass('ticketInformationBannerOpened');
			Cookies.set(
				cookieName,
				JSON.stringify(visitedTicketInformationBanners),
				{
					'expires': 180
				}
			);
		})
		.on('click', '.toggle-content', (event) => {
			const $toggleContent = $(event.currentTarget);

			$toggleContent.toggleClass('expanded');
			$toggleContent.closest('.ticketInformationBanner').find('.ticketInformationBannerText').toggleClass('show');
		})
		.on('click', '.showBtn', (event) => {
			const $banner = $(event.currentTarget).closest('.ticketInformationBanner');

			$banner.addClass('opened');
			$banner.find('.card-header, .show.showBtn').hide();
			$banner.siblings('.ticketInformationBannerOpenedBackground').toggle();
			$('body').addClass('ticketInformationBannerOpened');
		});
}